export enum UserConfigKeyEnum {
    reviewsFilter = 'reviewsFilter',
    reviewsHiddenStatuses = 'reviewsHiddenStatuses',
}
